import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-forum',
  templateUrl: 'forum.component.html',
  styleUrls: ['./forum.component.scss']
})
export class ForumComponent {
    @Input() item: any;
}
